import styled from 'styled-components';
import { Heading } from '@lendi-ui/typography';

export const BoldHeading = styled(Heading as any)`
  font-weight: bold;
`;
